import { useState, useEffect } from "react";
import { IKContext, IKUpload } from "imagekitio-react";

export const UploadForm = ({
    setProcessed,
    setUrl,
    setLoading,
    fileName,
}: {
    setProcessed: any;
    setUrl: any;
    setLoading: any;
    fileName: any;
}) => {
    const [btnLoad, setBtnLoad] = useState(false);
    const [err, setErr] = useState("");

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 2000);
    }, [setLoading]);

    return (
        <div className="p-2 rounded-xl shadow-xl bg-white w-2/6 max-sm:w-full">
            <h1 className="text-md inline-block py-3 px-2 text-gray-800">
                Upload image
            </h1>
            {err !== "" && (
                <div
                    className="p-3 mb-4 text-xs text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800"
                    role="alert"
                >
                    {err}
                </div>
            )}

            <label className="flex flex-col py-4 border-4 border-dashed border-gray-200 rounded-lg hover:bg-gray-100 hover:border-sky-400">
                <div className="flex flex-col items-center justify-center pt-7">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-12 h-12 text-gray-400 group-hover:text-sky-400"
                        fill="none"
                        viewBox="0 0 28 28"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                        />
                    </svg>
                    <p className="pt-1 text-sm tracking-wider text-gray-400 group-hover:text-sky-600">
                        Drop your image here
                    </p>
                </div>
                <IKContext
                    publicKey={process.env.REACT_APP_IK_PUBLIC_KEY}
                    urlEndpoint={process.env.REACT_APP_IK_URL}
                    authenticationEndpoint={process.env.REACT_APP_IK_AUTH_URL}
                >
                    <IKUpload
                        id="upload"
                        accept="image/*"
                        fileName={fileName}
                        folder="old"
                        useUniqueFileName={false}
                        isPrivateFile={false}
                        className="opacity-0"
                        disabled={btnLoad}
                        onError={(error) => {
                            setErr(error.message);
                            setBtnLoad(false);
                        }}
                        onSuccess={(response) => {
                            setUrl(response.url);
                            setProcessed(true);
                        }}
                        onChange={(event) => {
                            event.target.value && setBtnLoad(true);
                        }}
                    />
                </IKContext>
            </label>
            <div className="relative flex py-5 items-center">
                <div className="flex-grow border-t border-gray-200"></div>
                <span className="flex-shrink mx-4 text-xs text-gray-400">
                    OR
                </span>
                <div className="flex-grow border-t border-gray-200"></div>
            </div>

            <button
                type="button"
                className={`text-white text-xs ${
                    btnLoad
                        ? "bg-gray-200"
                        : "bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br shadow-lg shadow-blue-500/50 focus:ring-4 focus:outline-none focus:ring-blue-300 focus:shadow-none"
                }  transition duration-700 ease-in-out  dark:focus:ring-blue-800 dark:shadow-lgdark:shadow-blue-800/80 font-medium rounded-lg px-5 py-2.5 text-center mb-2 w-full`}
                onClick={() => {
                    setBtnLoad(true);
                    document.getElementById("upload")?.click();
                }}
                disabled={btnLoad}
            >
                {btnLoad ? (
                    <div>
                        {" "}
                        <svg
                            role="status"
                            className={`${
                                btnLoad ? "text-white" : "text-blue-600"
                            } inline mr-3 w-4 h-4  animate-spin`}
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentColor"
                            />
                        </svg>{" "}
                    </div>
                ) : (
                    <p>Choose from files</p>
                )}
            </button>
            <p className="pt-1 text-xs tracking-wider text-gray-800">
                Supported file types: *jpg, *png, *jpeg
            </p>
        </div>
    );
};
